var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lisa-configurator h-screen flex justify-between",class:_vm.initialized ? '' : 'is-loading'},[(!_vm.isMobile)?_c('drawer'):_c('drawer-mobile'),_c('viewport'),(!_vm.isMobile)?_c('sidebar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }